import { render, staticRenderFns } from "./GrowthRate.vue?vue&type=template&id=11249f89&scoped=true&"
import script from "./GrowthRate.vue?vue&type=script&lang=js&"
export * from "./GrowthRate.vue?vue&type=script&lang=js&"
import style0 from "./GrowthRate.vue?vue&type=style&index=0&id=11249f89&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11249f89",
  null
  
)

export default component.exports